import { render } from "./JournalPmpk.vue?vue&type=template&id=a07804ea&scoped=true"
import script from "./JournalPmpk.vue?vue&type=script&lang=js"
export * from "./JournalPmpk.vue?vue&type=script&lang=js"

import "./JournalPmpk.vue?vue&type=style&index=0&id=a07804ea&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07804ea"]])

export default __exports__